import React, {useEffect, useState} from "react";
import "./PeykMap.scss";
import {Map} from "../Map/Map";
import {PackManHederBack} from "../../PackMan/PackManHederBack/PackManHederBack";
import {useLocation} from "react-router-dom";
import {courier_orders_api} from "../PeykService";
import {BatchMap} from "../Map/BatchMap";

function PeykBachMap() {
    const [currents,set_currents] = useState([])

    useEffect(()=>{
        courier_orders_func();
    },[])


    const courier_orders_func = async ()=>{
        try {
            const response = await courier_orders_api(1)
            console.log("Response : ",response)
            // response.data.results[1]= {address:{coordinate:{lat:35.6892,lng:51.3890}}}
            // response.data.results[0].address.coordinate ={}
            // //response.data.results[0].address.coordinate ={lat:35.6892,lng:51.3890}
            // response.data.results[0].address.coordinate ={lat:32.6539,lng:51.6660}

            let locations = response.data.results.filter(item=>{
                return item.address && item.address.coordinate
            }).map(item=>{
                return {lat:item.address.coordinate.lat,lng:item.address.coordinate.lng}
            })

            console.log("Locations : ",locations)
            set_currents(locations)
        }catch (e) {
            console.log(e)
        }
    }

    return(
        <div>
            <PackManHederBack title={"مقصد سفارش"}/>
            <BatchMap coordinates={currents} />
        </div>
    )
}

export {PeykBachMap}
